import { DialogComponent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

/**
 * A custom element that manages a cart drawer.
 *
 * @extends {DialogComponent}
 */
class CartDrawerComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  #handleCartAdd = () => {
    if (this.hasAttribute('auto-open')) {
      this.showDialog();
    }
  };

  open() {
    this.showDialog();

    /**
     * Close cart drawer when installments CTA is clicked to avoid overlapping dialogs
     */
    customElements.whenDefined('shopify-payment-terms').then(() => {
      const installmentsContent = document.querySelector('shopify-payment-terms')?.shadowRoot;
      const cta = installmentsContent?.querySelector('#shopify-installments-cta');
      cta?.addEventListener('click', this.closeDialog, { once: true });
    });
  }

  close() {
    this.closeDialog();
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}
async function updateFreeShippingBar() {
  const bar = document.querySelector('.free-shipping-bar');
  if (!bar) return;

  const threshold = parseInt(bar.dataset.threshold, 10);

  const res = await fetch('/cart.js');
  if (!res.ok) return;

  const cart = await res.json();
  const total = Math.round(cart.total_price / 100);

  const message = bar.querySelector('.free-shipping-message');
  const progress = bar.querySelector('.progress');

  const remaining = threshold - total;
  const percent = Math.min((total / threshold) * 100, 100);

  if (remaining > 0) {
    message.innerHTML = `🚚 Te faltan <strong>$${remaining.toLocaleString('es-CO')}</strong> para envío GRATIS`;
    progress.style.width = `${percent}%`;
  } else {
    message.innerHTML = `🎉 ¡Tienes envío GRATIS!`;
    progress.style.width = `100%`;
  }
}

/* 👂 ESCUCHAR CUANDO EL DRAWER SE ABRE */
const waitForCartDrawer = () => {
  const dialog = document.querySelector('.cart-drawer__dialog');
  if (!dialog) {
    requestAnimationFrame(waitForCartDrawer);
    return;
  }

  const observer = new MutationObserver(() => {
    if (dialog.hasAttribute('open')) {
      // drawer acaba de abrir
      setTimeout(updateFreeShippingBar, 100);
    }
  });

  observer.observe(dialog, {
    attributes: true,
    attributeFilter: ['open']
  });
};

waitForCartDrawer();
